import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import App from './App';
import { GlobalStyles } from './styles/GlobalStyles';
import { getTheme } from './styles/theme';
import { ThemeProvider, useTheme } from './context/ThemeContext';

const ThemedApp = () => {
  const { mode } = useTheme();
  const theme = getTheme(mode);

  return (
    <StyledThemeProvider theme={theme}>
      <GlobalStyles />
      <App />
    </StyledThemeProvider>
  );
};

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <ThemedApp />
      </ThemeProvider>
    </BrowserRouter>
  </StrictMode>
);
